
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gE_45ZSV0PK_LlRHI0KBfIiHUPwGC3osiovxiSFiVz4PRcMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexcDxi9D2kL6m3jUOyx8mvG_acpRS3FP30Gm_45Fhh87TJUMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchoF7RUxsOo30cgLCEkzSuteMQcxGTBljPjLZSS6nCbKwMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexu16MZ8sCxjkxtm1dpjhGAEbTn5bUrBq_452R3ho7BCBS0Meta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93S6erI3wXVPwF6Ul0G53v7tCmckZGmWJAxElXX_DYbxoMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexQrnDAqD5TyYwWh4c8TyFgeET2fZCBFn9Z0MLH8FsR40Meta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93k5nR66jrD7MSKF8w8inzIud9a5zYYFiRX3grVvtAwkUMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexkIX6pMBjBgqUV821AsZZBz_ueDFa8fga9xSFhmfozzoMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93rrwag4vSBxWdeEgriAnfZUao1QuGM49Efe4vbKUEaEUMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexwNwDveDLb021Bu6yOier1fqDn2KTHuca8HPY6J9F_DoMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexbRTasW4KE0Uie5Coo2j4sczkVTBhrA97xKkDhVsjrtUMeta } from "/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexQrnDAqD5TyYwWh4c8TyFgeET2fZCBFn9Z0MLH8FsR40Meta || {},
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexkIX6pMBjBgqUV821AsZZBz_ueDFa8fga9xSFhmfozzoMeta || {},
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexwNwDveDLb021Bu6yOier1fqDn2KTHuca8HPY6J9F_DoMeta || {},
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexbRTasW4KE0Uie5Coo2j4sczkVTBhrA97xKkDhVsjrtUMeta || {},
    component: () => import("/codebuild/output/src1688897962/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]